/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnChanges, signal} from '@angular/core';
import template from './role-analysis-page.component.html';

import {loadRoleAnalysisUsers} from './role-commons';
import {TeamApiService} from '../team/team-api.service';
import {UserApiService} from '../user/user-api.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {deferSignalViewWrite} from '../../common/util/template-state';
import {AppSharedModule} from '../../common/app-shared.module';
import {UIRouterModule} from '@uirouter/angular';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule],
  selector: 'adn-role-analysis-page',
  template
})
export class RoleAnalysisPageComponent implements OnChanges {
  @Input() model: any;
  @Input() isNew: boolean;

  users: any[] = [];
  loading = false;
  loaded = false;
  readonly viewRevision = signal(0);

  constructor(
    private readonly teamApi: TeamApiService,
    private readonly userApi: UserApiService,
    @Inject(LocalNetworkProfile) private LocalNetworkProfile: any
  ) {
  }

  get displayLoaded(): boolean {
    this.viewRevision();
    return this.loaded;
  }

  ngOnChanges(): void {
    this.refreshUsers();
  }

  trackByUserId(_index: number, user: any): string {
    return user.id;
  }

  trackByTeamId(_index: number, team: any): string {
    return team.id || team.name;
  }

  private refreshUsers(): void {
    if (this.isNew || !this.model?.id) {
      this.users = [];
      this.loading = false;
      this.loaded = true;
      return;
    }

    this.loading = true;
    this.loaded = false;
    loadRoleAnalysisUsers(this.model, this.teamApi, this.userApi, this.LocalNetworkProfile).then((users) => {
      deferSignalViewWrite(this.viewRevision, () => {
        this.users = users;
        this.loading = false;
        this.loaded = true;
      });
    }).catch(() => {
      deferSignalViewWrite(this.viewRevision, () => {
        this.users = [];
        this.loading = false;
        this.loaded = true;
      });
    });
  }
}
